import Vue from 'vue'
import App from './App'
import router from './router'
import TRTCCalling from 'trtc-calling-js';
import TRTC from 'trtc-js-sdk';
import store from './store/index'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ajax from './utils/request.js';
import './styles/public.css';

Vue.use(ElementUI);

Vue.config.productionTip = false
// let options = {
//     SDKAppID: 1400554928
// };
// Vue.prototype.$trtcCalling = new TRTCCalling(options)
// Vue.prototype.TRTCCalling = TRTCCalling;
// Vue.prototype.TRTC = TRTC;

Vue.prototype.$api = 'https://rk.shouhuojiyun.com/rk_medicine_api';
Vue.prototype.$get = ajax.get;
Vue.prototype.$noloadingget = ajax.noloadingget;
Vue.prototype.$post = ajax.post;
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js